<script>
import Modal from './utilities/Modal'

export default {
  name: 'Terms',
  components: {
    Modal,
  },
  props: ['terms'],
  data() {
    return {
      showTerms: false,
    }
  },
}
</script>

<template>
  <div>
    <div
      class="cursor-pointer"
      @click="showTerms = true"
    >
      <slot />
    </div>

    <ClientOnly>
      <Teleport to="#portal-destination">
        <Modal
          v-if="showTerms"
          key="sign-up-form"
          @close="showTerms = false"
        >
          <div class="relative bg-white max-w-5xl p-12 max-h-[70vh] overflow-y-auto">
            <button
              class="absolute top-4 right-6"
              @click="showTerms = false"
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                fill="none"
                viewBox="0 0 24 24"
                stroke-width="1.5"
                stroke="currentColor"
                class="size-12"
              >
                <path
                  stroke-linecap="round"
                  stroke-linejoin="round"
                  d="M6 18L18 6M6 6l12 12"
                />
              </svg>
            </button>
            <h3
              class="text-sans font-bold text-2xl"
              v-html="$t('terms-and-conditions')"
            />
            <div
              class="pt-12"
              v-html="terms"
            />
          </div>
        </Modal>
      </Teleport>
    </ClientOnly>
  </div>
</template>
